import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({
    key: 'cubeSelector',
    paths: [
      'user',
      'lastPage',
      'userToken',
      'favorites',
      'form',
      'expires'
    ]
  })],
  state: {
    highlighted: null,
    expires: null,
    filters: {},
    filtersActive: false,
    apiData: {},
    favoriteLimitReached: false,
    userToken: null,
    user: {},
    form: {
      targets: {}
    },
    maxRentalPrice: 0,
    favorites: [],
    filteredIds: [],
    lastPage: null
  },
  methods: {
    //
  },
  mutations: {
    expired (state) {
      state.expired = Math.floor(Date.now() / 1000) + (3600 * 8)
      state.form = {}
      state.user = {}
      state.userToken = null
      state.favorites = []
    },
    setApiData (state, data) {
      data.objects = Object.values(data.objects)
      state.apiData = data
      state.expires = Math.floor(Date.now() / 1000) + (3600 * 8)
    },
    lastPage (state, data) {
      state.lastPage = data
    },
    setUserToken (state, data) {
      state.userToken = data
    },
    setUser (state, data) {
      state.user = data
      if(state.favorites.length === 0 && data.objects && data.objects.length){
        state.favorites = data.objects
      }
    },
    addFavorite(state, data) {
      if(!state.favorites.includes(data)){
        state.favorites.push(data)
      }
    },
    setFavorites (state, data) {
      state.favorites = data
    },
    removeFavorite(state, data){
      if(state.favorites.includes(data)) {
        let index = state.favorites.indexOf(data)
        state.favorites.splice(index, 1)
      }
    },
    favoriteLimitReached(state, data){
      state.favoriteLimitReached = data
    },
    setFilters(state, data){
      state.filters = data
    },
    filtersActive(state, data){
      this.state.filtersActive = data
    },
    saveStep(state, data){
      Object.entries(data).forEach((row) => {
        state.form[row[0]] = row[1]
      })
    },
    clearForm(state) {
      state.form = {
        targets: {}
      }
    },
    rentalPrice(state, data){
      state.maxRentalPrice = data
    },
    filteredIds(state, data){
      state.filteredIds = data
    },
    highlight(state, data){
      state.highlighted = data
    }
  }
})
